<template>
  <div
    class="tw-w-auto tw-py-1 tw-px-3 tw-box-border tw-flex tw-items-center tw-gap-2 tw-rounded-lg tw-border-[2px] tw-border-[#40AE42] tw-border-solid"
  >
    <CheckGreenShield />
    <Text variant="xsmall" whiteSpace="nowrap">{{ props.label }}</Text>
  </div>
</template>
<script setup>
import Text from "../ui/general/Text.vue";
import CheckGreenShield from "../icons/CheckGreenShield.vue";

const props = defineProps({
  label: {
    type: String,
    default: "Verified",
  },
});
</script>
<style lang="scss" scoped></style>
